import { render } from "./CreateResponse.vue?vue&type=template&id=385487a2&scoped=true"
import script from "./CreateResponse.vue?vue&type=script&lang=js"
export * from "./CreateResponse.vue?vue&type=script&lang=js"

import "./CreateResponse.vue?vue&type=style&index=0&id=385487a2&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385487a2"]])

export default __exports__